export default __webpack_public_path__ + "static/media/YAS0920.34I-42444_-25429_0.ba94ad3a.jpg";